<template>
  <div>
    <Header />
    <v-img
      :src="require('@/assets/bannerProvUbicacion.jpg')"
      :lazy-src="require('@/assets/carruselLazyLoad.jpg')"
      aspect-ratio="3.65"
      contain
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>

    <v-row align="center" justify="center" no-gutters>
      <v-breadcrumbs :items="itemsBreadCrumbs" large>
        <template v-slot:divider>
          <v-icon>mdi-forward</v-icon>
        </template>
      </v-breadcrumbs>
    </v-row>

    <v-col cols="12" class="pt-5">
      <v-row align="center" justify="center">
        <v-card
          class="ma-3 pa-6"
          style="border: 0px solid white"
          width="700"
          outlined
          tile
        >
          <p
            class="subfont text-justify text-center mb-0"
            :class="[
              $vuetify.breakpoint.mdAndUp ? 'subfont' : 'subfontResponsive',
            ]"
          >
            Amplia red de proveedores estrátegicamente ubicados en las
            principales ciudades y carreteras de tráfico internacional que se
            traduce en tiempos de respuesta cortas.
          </p>
        </v-card>
      </v-row>
    </v-col>

    <v-container>
      <v-row class="d-flex justify-space-around">
        <v-col cols="12" md="5">
          <div
            id="mapContainer"
            class="mx-auto"
            style="max-width:600px; height: 550px"
          ></div>
        </v-col>

        <v-col cols="12" md="5" class="my-auto">
          <v-card max-width="395" class="mx-auto">
            <v-card-title
              class="text-xl-h4 pt-1"
              :class="[
                $vuetify.breakpoint.mdAndUp
                  ? 'fontTitulo'
                  : 'fontTituloResponsive',
              ]"
              >CON PRESENCIA EN:</v-card-title
            >
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>FRONTERA EL GUASAULE</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(1)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>ESTELI</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(2)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>CHINANDEGA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(3)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>LEÓN</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(4)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>MANAGUA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(5)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>MASAYA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(6)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>GRANADA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(7)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>RIVAS</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(8)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>FRONTERA PEÑAS BLANCAS</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(9)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <ButtonScroll />
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ButtonScroll from "../components/ButtonScroll.vue";
import mapboxgl from "mapbox-gl";

export default {
  components: {
    Header,
    Footer,
    ButtonScroll,
  },
  data: () => ({
    markers: [
      {
        id: 1,
        name: "FRONTERA EL GUASAULE",
        position: {
          lat: 13.061952,
          lng: -86.950371,
        },
      },
      {
        id: 2,
        name: "ESTELI",
        position: {
          lat: 13.092316,
          lng: -86.355628,
        },
      },
      {
        id: 3,
        name: "CHINANDEGA",
        position: {
          lat: 12.630224,
          lng: -87.131109,
        },
      },
      {
        id: 4,
        name: "LEÓN",
        position: {
          lat: 12.435411,
          lng: -86.879933,
        },
      },
      {
        id: 5,
        name: "MANAGUA",
        position: {
          lat: 12.131047,
          lng: -86.265839,
        },
      },
      {
        id: 6,
        name: "MASAYA",
        position: {
          lat: 11.973751,
          lng: -86.093326,
        },
      },
      {
        id: 7,
        name: "GRANADA",
        position: {
          lat: 11.930192,
          lng: -85.955336,
        },
      },
      {
        id: 8,
        name: "RIVAS",
        position: {
          lat: 11.439184,
          lng: -85.829143,
        },
      },
      {
        id: 9,
        name: "FRONTERA PEÑAS BLANCAS",
        position: {
          lat: 11.218045,
          lng: -85.613515,
        },
      },
    ],
    itemsBreadCrumbs: [
      {
        text: "HOME",
        disabled: false,
        href: "/",
      },
      {
        text: "NUESTROS PROVEEDORES NICARAGUA",
        disabled: true,
        href: "",
      },
    ],
    map: "",
    accessToken:
      "pk.eyJ1Ijoiam9obmxpbmFyZXMiLCJhIjoiY2tjcWk2eDZrMTU2bjJyczVyMWF0ejg3NiJ9.848u9JaZDYfKTRPBzFvDwA",
  }),

  mounted() {
    mapboxgl.accessToken = this.accessToken;
    this.map = new mapboxgl.Map({
      container: "mapContainer",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [-85.050684, 12.822514],
      zoom: 6,
    });
    for (var i = 0; i < this.markers.length; i++) {
      var marker = new mapboxgl.Marker({ color: "blue" })
        .setLngLat(this.markers[i].position)
        .setPopup(
          new mapboxgl.Popup({ offset: 25 }).setHTML(
            "<strong>" + this.markers[i].name + "</strong>"
          )
        )
        .addTo(this.map);
    }
    this.map.addControl(new mapboxgl.FullscreenControl());
    this.map.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
        },
        trackUserLocation: true,
      })
    );
    this.map.addControl(new mapboxgl.NavigationControl());
  },

  methods: {
    Flyto(i) {
      switch (i) {
        case 1:
          var center = this.markers[i - 1].position;
          break;
        case 2:
          var center = this.markers[i - 1].position;
          break;
        case 3:
          var center = this.markers[i - 1].position;
          break;
        case 4:
          var center = this.markers[i - 1].position;
          break;
        case 5:
          var center = this.markers[i - 1].position;
          break;
        case 6:
          var center = this.markers[i - 1].position;
          break;
        case 7:
          var center = this.markers[i - 1].position;
          break;
        case 8:
          var center = this.markers[i - 1].position;
          break;
        case 9:
          var center = this.markers[i - 1].position;
          break;
      }
      this.map.flyTo({
        center: center,
        zoom: 13,
        bearing: 0,
        speed: 0.5,
        curve: 1,
        easing: function(t) {
          return t;
        },
        essential: true,
      });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Zilla+Slab:ital,wght@1,700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=EB+Garamond:wght@500&family=Zilla+Slab:ital,wght@1,700&display=swap");

.subfont {
  font-family: "EB Garamond", serif;
  font-size: 25px;
}
.subfontResponsive {
  font-family: "EB Garamond", serif;
  font-size: 15px;
}
</style>
